import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const modules = [{
  num: '01',
  title: 'El Sistema',
  description: 'La ciencia detrás del segundo cerebro y el eje intestino-cerebro. Comprende por qué tu intestino dirige tu energía, tu peso y tu claridad mental.'
}, {
  num: '02',
  title: 'El Protocolo',
  description: 'Guía maestra de suplementación e ingredientes para sellar la barrera intestinal y eliminar la inflamación crónica desde la raíz.'
}, {
  num: '03',
  title: 'Plan de Acción',
  description: 'Calendario de 21 días, diario de síntomas y recetario anti-inflamatorio premium. Todo lo que necesitas para ejecutar sin pensar.'
}];
export function ProductStack() {
  return <section className="py-32 md:py-44 bg-forest text-white" data-id="element-152">
      <div className="container mx-auto px-6 max-w-5xl" data-id="element-153">
        <div className="text-center mb-20 md:mb-24" data-id="element-154">
          <span className="text-sage/60 font-sans font-semibold tracking-[0.3em] text-xs uppercase mb-5 block" data-id="element-155">
            Arquitectura del Protocolo
          </span>
          <h2 className="font-serif text-4xl md:text-5xl font-semibold tracking-tight leading-[1.05] max-w-3xl mx-auto" data-id="element-156">
            Un sistema en tres movimientos.
          </h2>
        </div>

        <div className="space-y-px" data-id="element-157">
          {modules.map((m, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="flex flex-col md:flex-row md:items-start gap-6 md:gap-12 py-10 md:py-12 border-t border-white/10 last:border-b" data-id="element-158">
              <div className="md:w-32 shrink-0" data-id="element-159">
                <span className="font-serif text-5xl md:text-6xl font-light text-sage/70 tracking-tighter leading-none" data-id="element-160">
                  {m.num}
                </span>
              </div>
              <div className="flex-1" data-id="element-161">
                <h3 className="font-serif text-2xl md:text-3xl font-semibold mb-3 tracking-tight" data-id="element-162">
                  Módulo {m.num.replace('0', '')}: {m.title}
                </h3>
                <p className="font-sans text-base md:text-lg text-white/65 leading-relaxed max-w-2xl" data-id="element-163">
                  {m.description}
                </p>
              </div>
            </motion.div>)}
        </div>

        {/* What's included recap */}
        <div className="mt-20 md:mt-24 pt-12 border-t border-white/10" data-id="element-164">
          <p className="font-sans text-xs font-bold tracking-[0.3em] uppercase text-sage/60 mb-6 text-center" data-id="element-165">
            Incluido en tu acceso
          </p>
          <div className="flex flex-col md:flex-row items-start md:items-center justify-center gap-x-10 gap-y-3 text-base font-sans" data-id="element-166">
            {['3 Módulos Maestro', 'Planificador de 21 Días', 'Recetario Gourmet Anti-inflamatorio'].map(item => <div key={item} className="flex items-center gap-2.5" data-id="element-167">
                <CheckCircle2 className="w-4 h-4 text-sage shrink-0" data-id="element-168" />
                <span className="text-white/85" data-id="element-169">{item}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}